// @ts-nocheck
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const titleStyles = (breakpoints: Array<Amount | null>) => css`
    ${spacingStyles("1em", "0.5em")}
    ${breakpointValues(pxToRemArray(breakpoints), "font-size")}
    ${({ theme }) => `
        font-family: ${theme.design.typography.fontFamily.title};
        font-weight: ${theme.design.typography.weight.bold};
    `}
`;

const typography: Styleguide["typography"] = {
    fontFamilyImportUrl: "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap", // Store Custom Code
    body: {
        size: "inherit",
        weight: "inherit",
        fontFamily: "inherit",
        css: css`
            ${({ theme }) => `
                font-family: ${theme.design.typography.fontFamily.base};
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: spacingStyles(),
    },
    h1: {
        css: css`
            ${titleStyles([31, null, 37, null, 48])}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h2: {
        css: css`
            ${titleStyles([21, null, null, null, 22])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    h3: {
        css: css`
            ${titleStyles([19, null, 20])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h4: {
        css: css`
            ${titleStyles([18])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h5: {
        css: css`
            ${titleStyles([16])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    h6: {
        css: css`
            ${titleStyles([14])} /* Store Custom Code */
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    legend: {
        size: "inherit",
        weight: "inherit",
        color: null as any,
        transform: null as any,
        css: css`
            color: ${getColor("text.accent")};
            text-transform: uppercase;

            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smallest};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.base};
            `};

            && + ${FormInputWrapper}, && + ${FormFieldStyle} {
                margin-top: ${pxToRem(3)};
            }
        `,
    },
};

export default typography;
